// Kyloo translations — Italian (default) & English
// Scope: buyer-facing pages (Welcome, Home, Cerca, Dettaglio prodotto, Negozio,
// navigation, login modals, header). Shop-owner dashboard remains Italian.

export const TRANSLATIONS = {
  it: {
    common: {
      loading: 'Caricamento...',
      back: 'Indietro',
      close: 'Chiudi',
      cancel: 'Annulla',
      save: 'Salva',
      confirm: 'Conferma',
      yes: 'Sì',
      no: 'No',
      search: 'Cerca',
      retry: 'Riprova',
      goBack: 'Torna indietro',
      results_one: 'risultato',
      results_other: 'risultati',
      or: 'oppure',
    },
    lang: {
      label: 'Lingua',
      it: 'Italiano',
      en: 'Inglese',
    },
    nav: {
      home: 'Home',
      search: 'Cerca',
      discover: 'Scopri',
    },
    welcome: {
      tagline: 'Trova prodotti nei negozi vicini',
      subTagline: 'Acquista subito, senza aspettare',
      guest: 'Continua come ospite',
      login: 'Accedi',
      register: 'Registrati',
    },
    header: {
      search_placeholder: 'Cerca prodotto vicino a te',
      location: 'Posizione',
      set_location_title: 'Imposta la tua posizione',
      use_gps: 'Usa la mia posizione GPS',
      detecting: 'Rilevamento in corso...',
      manual_city_placeholder: 'Inserisci città o CAP',
      manual_street_placeholder: 'Via e numero civico (facoltativo)',
      gps_failed_hint: 'GPS non disponibile. Inserisci la tua città (e la via per maggiore precisione).',
      confirm_location: 'Conferma posizione',
      current_location: 'Posizione attuale:',
      menu_login: 'Accedi o registrati',
      menu_favorites: 'Negozi preferiti',
      menu_suggestions: 'Suggerimenti',
      menu_language: 'Lingua',
      menu_logout: 'Esci',
      menu_dashboard: 'Gestisci negozio',
      menu_become_pro: 'Diventa professionista',
      menu_admin: 'Admin Dashboard',
      continue_as_guest: 'Continua come ospite',
      notifications: 'Notifiche',
      notifications_count_zero: 'Tutto aggiornato! Nessuna novità.',
      notifications_new_one: '{n} nuovo prodotto nei negozi preferiti',
      notifications_new_other: '{n} nuovi prodotti nei negozi preferiti',
      no_favorites_guest: 'Accedi per ricevere notifiche.',
      no_favorites: 'Aggiungi negozi ai preferiti per ricevere notifiche sui nuovi prodotti.',
      go_to_favorites: 'Vai ai preferiti',
      new_products_one: 'nuovo prodotto',
      new_products_other: 'nuovi prodotti',
      suggestion_title: 'Suggerimenti',
      suggestion_desc: 'Aiutaci a migliorare Kyloo con le tue idee',
      suggestion_type: 'Tipo di suggerimento',
      suggestion_type_placeholder: "Seleziona un'opzione",
      suggestion_type_bug: 'Bug',
      suggestion_type_idea: 'Idea nuova',
      suggestion_type_improvement: 'Miglioramento',
      suggestion_type_other: 'Altro',
      suggestion_message: 'Il tuo messaggio',
      suggestion_placeholder: 'Descrivi brevemente la tua idea o il problema...',
      suggestion_motivational: 'Le idee migliori verranno implementate nelle prossime versioni',
      suggestion_send: 'Invia suggerimento',
      suggestion_sending: 'Invio in corso...',
      suggestion_thanks_title: 'Grazie per il tuo contributo!',
      suggestion_thanks_msg: 'Il tuo suggerimento è stato ricevuto. Apprezziamo il tuo aiuto nel migliorare Kyloo.',
      suggestion_error_empty: 'Seleziona un tipo e scrivi il tuo suggerimento',
      suggestion_success_toast: 'Grazie per il tuo suggerimento!',
    },
    home: {
      products_title: 'Prodotti disponibili vicino a te',
      products_category_title: '{category} disponibili vicino a te',
      empty_title: 'Nessun prodotto trovato',
      empty_with_location: 'Non ci sono prodotti disponibili in questa zona',
      empty_no_location: 'Imposta la tua posizione per vedere i prodotti vicini',
    },
    search: {
      all_products: 'Tutti i prodotti',
      results_for: 'Risultati per:',
      remove_filter: 'Rimuovi filtro',
      empty_title: 'Nessun risultato',
      empty_msg: 'Prova con termini di ricerca diversi o modifica i filtri',
    },
    filters: {
      title: 'Filtri',
      label: 'Filtri',
      max_distance: 'Distanza massima',
      within_km: 'Entro {km} km',
      no_limit: 'Nessun limite',
      price_range: 'Fascia di prezzo',
      min_price: 'Min €',
      max_price: 'Max €',
      available_only: 'Solo prodotti disponibili',
      reset: 'Resetta',
      apply: 'Applica filtri',
    },
    categories: {
      eventi: 'Eventi',
      moda: 'Moda',
      elettronica: 'Elettronica',
      fai_da_te: 'Fai da te',
      servizi: 'Servizi',
      idee_regalo: 'Idee regalo',
      nuovi: 'Nuovi su Kyloo',
    },
    events: {
      pill: 'Eventi',
      modal_title: 'Eventi e mercati',
      modal_subtitle: 'Posizioni temporanee di ambulanti e attività miste nei prossimi 30 giorni',
      empty_title: 'Nessun evento programmato al momento.',
      empty_subtitle: 'Torna a controllare presto!',
      on_today: 'In corso oggi',
      on_map: 'Sulla mappa',
      aria_new: 'Nuovi eventi',
    },
    product: {
      available_now: 'Disponibile ora',
      available: 'Disponibile',
      sold_out: 'Esaurito',
      opens_at: 'Apre {time}',
      price_in_store: 'Prezzo in negozio',
      not_found: 'Prodotto non trovato',
      description: 'Descrizione',
      available_at_shop: 'Disponibile in questo negozio:',
      go_to_shop: 'Vai al negozio',
      go_to_event: "Vai all'evento",
      view_image: 'Visualizza immagine',
      open: 'Aperto',
      closed: 'Chiuso',
      open_now: 'Aperto ora',
    },
    shop: {
      not_found: 'Negozio non trovato',
      verified: 'Verificato',
      directions: 'Indicazioni stradali',
      products_title: 'Prodotti',
      no_products: 'Nessun prodotto disponibile',
      closure_title: 'Chiusura straordinaria',
      closure_reopening: 'Riapertura il {date}',
      upcoming_stops: 'Prossime tappe',
      on_map_simple: 'Posizione sulla mappa',
      from_date_to_date: 'Dal {from_date} ({from_time}) al {to_date} ({to_time})',
      opening_hours: 'Orari di apertura',
      days: {
        lunedi: 'Lunedì',
        martedi: 'Martedì',
        mercoledi: 'Mercoledì',
        giovedi: 'Giovedì',
        venerdi: 'Venerdì',
        sabato: 'Sabato',
        domenica: 'Domenica',
      },
    },
    auth: {
      login_title: 'Accedi al tuo account',
      login_subtitle: 'Scegli come accedere',
      login_email_title: 'Accedi',
      login_email_subtitle: 'Inserisci le tue credenziali',
      reg_role_title: 'Registrati',
      reg_role_subtitle: 'Sei un cliente o un professionista?',
      reg_pro_title: 'Registrazione attività',
      reg_client_title: 'Registrati come cliente',
      reg_method_subtitle: 'Scegli come continuare',
      reg_email_title: 'Crea il tuo account',
      reg_email_subtitle: 'Bastano pochi secondi',
      google_login: 'Accedi con Google',
      google_continue: 'Continua con Google',
      email_login_btn: 'Inserisci email e password',
      email_register_btn: 'Registrati con email e password',
      switch_to_register: 'Non hai un account? Registrati',
      switch_to_login: 'Hai già un account? Accedi',
      email: 'Email',
      password: 'Password',
      password_placeholder: 'La tua password',
      password_min: 'Min. 8 caratteri',
      name: 'Nome',
      shop_name: 'Nome attività',
      role_client: 'Cliente',
      role_client_desc: 'Cerco prodotti nei negozi vicino a me',
      role_pro: 'Professionista',
      role_pro_desc: 'Voglio vendere prodotti o servizi sulla piattaforma',
      registering_as_pro: 'Stai registrando un account professionista',
      registering_as_client: 'Stai registrando un account cliente',
      category_label: 'Categoria attività *',
      selected_category: 'Categoria selezionata:',
      login_submit: 'Accedi',
      register_submit: 'Crea account',
      err_missing_credentials: 'Inserisci email e password',
      err_fill_all: 'Compila tutti i campi',
      err_password_min: 'La password deve avere almeno 8 caratteri',
      err_generic: 'Si è verificato un errore. Riprova.',
      err_login: 'Login fallito',
      err_register: 'Registrazione fallita',
      welcome_back: 'Bentornato, {name}!',
      welcome_new: 'Benvenuto, {name}!',
      cat_negozio: 'Negozio',
      cat_negozio_desc: 'Punto vendita singolo',
      cat_ambulante: 'Ambulante',
      cat_ambulante_desc: 'Vendita in mercati e/o luoghi variabili',
      cat_misto: 'Misto',
      cat_misto_desc: 'Negozio + mercati',
      cat_tecnico: 'Tecnico',
      cat_tecnico_desc: 'Servizi a domicilio',
      cat_servizi_sede: 'Servizi in sede',
      cat_servizi_sede_desc: 'Lavori in sede senza vendita (parrucchiere, meccanico…)',
    },
    footer: {
      privacy: 'Privacy',
      terms: 'Termini',
      cookie: 'Cookie',
      contact: 'Contatti',
      copyright: '© {year} Kyloo · Versione Beta gratuita',
    },
    reviews: {
      title: 'Recensioni',
      review_one: 'recensione',
      review_other: 'recensioni',
      leave_review: 'Lascia una recensione',
      your_rating: 'La tua valutazione *',
      your_comment: 'Commento (opzionale)',
      comment_placeholder: "Racconta brevemente la tua esperienza con questo negozio…",
      publish: 'Pubblica',
      update: 'Aggiorna recensione',
      thanks: 'Grazie per la tua recensione!',
      updated: 'Recensione aggiornata',
      deleted: 'Recensione eliminata',
      your_review: 'La tua recensione',
      empty: 'Nessuna recensione ancora.',
      empty_be_first: 'Nessuna recensione ancora. Sii il primo!',
      login_to_review: 'Accedi per lasciare una recensione.',
      owner_response: 'Risposta del negoziante',
      reply: 'Rispondi',
      reply_placeholder: 'Scrivi una risposta…',
      reply_sent: 'Risposta pubblicata',
      flag: 'Segnala',
      flagged: 'Recensione segnalata agli amministratori',
      flagged_label: 'Segnalata',
      confirm_delete: 'Eliminare la tua recensione?',
      confirm_flag: 'Segnalare questa recensione agli amministratori?',
      err_no_stars: 'Seleziona almeno 1 stella',
      err_generic: 'Si è verificato un errore. Riprova.',
    },
  },

  en: {
    common: {
      loading: 'Loading...',
      back: 'Back',
      close: 'Close',
      cancel: 'Cancel',
      save: 'Save',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      search: 'Search',
      retry: 'Retry',
      goBack: 'Go back',
      results_one: 'result',
      results_other: 'results',
      or: 'or',
    },
    lang: {
      label: 'Language',
      it: 'Italian',
      en: 'English',
    },
    nav: {
      home: 'Home',
      search: 'Search',
      discover: 'Discover',
    },
    welcome: {
      tagline: 'Find products in nearby stores',
      subTagline: 'Buy now, no waiting',
      guest: 'Continue as guest',
      login: 'Sign in',
      register: 'Sign up',
    },
    header: {
      search_placeholder: 'Search a product near you',
      location: 'Location',
      set_location_title: 'Set your location',
      use_gps: 'Use my GPS location',
      detecting: 'Detecting...',
      manual_city_placeholder: 'Enter city or ZIP code',
      manual_street_placeholder: 'Street and number (optional)',
      gps_failed_hint: 'GPS not available. Enter your city (and street for more accuracy).',
      confirm_location: 'Confirm location',
      current_location: 'Current location:',
      menu_login: 'Sign in or sign up',
      menu_favorites: 'Favorite shops',
      menu_suggestions: 'Suggestions',
      menu_language: 'Language',
      menu_logout: 'Sign out',
      menu_dashboard: 'Manage shop',
      menu_become_pro: 'Become a professional',
      menu_admin: 'Admin Dashboard',
      continue_as_guest: 'Continue as guest',
      notifications: 'Notifications',
      notifications_count_zero: 'All caught up! No news.',
      notifications_new_one: '{n} new product in your favorite shops',
      notifications_new_other: '{n} new products in your favorite shops',
      no_favorites_guest: 'Sign in to receive notifications.',
      no_favorites: 'Add shops to favorites to get notified of new products.',
      go_to_favorites: 'Go to favorites',
      new_products_one: 'new product',
      new_products_other: 'new products',
      suggestion_title: 'Suggestions',
      suggestion_desc: 'Help us improve Kyloo with your ideas',
      suggestion_type: 'Suggestion type',
      suggestion_type_placeholder: 'Select an option',
      suggestion_type_bug: 'Bug',
      suggestion_type_idea: 'New idea',
      suggestion_type_improvement: 'Improvement',
      suggestion_type_other: 'Other',
      suggestion_message: 'Your message',
      suggestion_placeholder: 'Briefly describe your idea or the issue...',
      suggestion_motivational: 'The best ideas will be implemented in future versions',
      suggestion_send: 'Send suggestion',
      suggestion_sending: 'Sending...',
      suggestion_thanks_title: 'Thank you for your contribution!',
      suggestion_thanks_msg: 'Your suggestion has been received. We appreciate your help in improving Kyloo.',
      suggestion_error_empty: 'Select a type and write your suggestion',
      suggestion_success_toast: 'Thanks for your suggestion!',
    },
    home: {
      products_title: 'Products available near you',
      products_category_title: '{category} available near you',
      empty_title: 'No products found',
      empty_with_location: 'No products available in this area',
      empty_no_location: 'Set your location to see nearby products',
    },
    search: {
      all_products: 'All products',
      results_for: 'Results for:',
      remove_filter: 'Remove filter',
      empty_title: 'No results',
      empty_msg: 'Try different search terms or adjust the filters',
    },
    filters: {
      title: 'Filters',
      label: 'Filters',
      max_distance: 'Maximum distance',
      within_km: 'Within {km} km',
      no_limit: 'No limit',
      price_range: 'Price range',
      min_price: 'Min €',
      max_price: 'Max €',
      available_only: 'Available products only',
      reset: 'Reset',
      apply: 'Apply filters',
    },
    categories: {
      eventi: 'Events',
      moda: 'Fashion',
      elettronica: 'Electronics',
      fai_da_te: 'DIY',
      servizi: 'Services',
      idee_regalo: 'Gift ideas',
      nuovi: 'New on Kyloo',
    },
    events: {
      pill: 'Events',
      modal_title: 'Events & markets',
      modal_subtitle: 'Temporary locations of street vendors and mixed businesses in the next 30 days',
      empty_title: 'No events scheduled right now.',
      empty_subtitle: 'Check back soon!',
      on_today: 'Ongoing today',
      on_map: 'On the map',
      aria_new: 'New events',
    },
    product: {
      available_now: 'Available now',
      available: 'Available',
      sold_out: 'Sold out',
      opens_at: 'Opens {time}',
      price_in_store: 'Price in store',
      not_found: 'Product not found',
      description: 'Description',
      available_at_shop: 'Available at this shop:',
      go_to_shop: 'Go to shop',
      go_to_event: 'Go to event',
      view_image: 'View image',
      open: 'Open',
      closed: 'Closed',
      open_now: 'Open now',
    },
    shop: {
      not_found: 'Shop not found',
      verified: 'Verified',
      directions: 'Get directions',
      products_title: 'Products',
      no_products: 'No products available',
      closure_title: 'Temporary closure',
      closure_reopening: 'Reopening on {date}',
      upcoming_stops: 'Upcoming stops',
      on_map_simple: 'Location on the map',
      from_date_to_date: 'From {from_date} ({from_time}) to {to_date} ({to_time})',
      opening_hours: 'Opening hours',
      days: {
        lunedi: 'Monday',
        martedi: 'Tuesday',
        mercoledi: 'Wednesday',
        giovedi: 'Thursday',
        venerdi: 'Friday',
        sabato: 'Saturday',
        domenica: 'Sunday',
      },
    },
    auth: {
      login_title: 'Sign in to your account',
      login_subtitle: 'Choose how to sign in',
      login_email_title: 'Sign in',
      login_email_subtitle: 'Enter your credentials',
      reg_role_title: 'Sign up',
      reg_role_subtitle: 'Are you a customer or a professional?',
      reg_pro_title: 'Business registration',
      reg_client_title: 'Sign up as customer',
      reg_method_subtitle: 'Choose how to continue',
      reg_email_title: 'Create your account',
      reg_email_subtitle: 'Takes only a few seconds',
      google_login: 'Sign in with Google',
      google_continue: 'Continue with Google',
      email_login_btn: 'Enter email and password',
      email_register_btn: 'Sign up with email and password',
      switch_to_register: "Don't have an account? Sign up",
      switch_to_login: 'Already have an account? Sign in',
      email: 'Email',
      password: 'Password',
      password_placeholder: 'Your password',
      password_min: 'Min. 8 characters',
      name: 'Name',
      shop_name: 'Business name',
      role_client: 'Customer',
      role_client_desc: 'I look for products in shops near me',
      role_pro: 'Professional',
      role_pro_desc: 'I want to sell products or services on the platform',
      registering_as_pro: "You're registering a professional account",
      registering_as_client: "You're registering a customer account",
      category_label: 'Business category *',
      selected_category: 'Selected category:',
      login_submit: 'Sign in',
      register_submit: 'Create account',
      err_missing_credentials: 'Enter email and password',
      err_fill_all: 'Fill in all fields',
      err_password_min: 'Password must be at least 8 characters',
      err_generic: 'An error occurred. Please retry.',
      err_login: 'Login failed',
      err_register: 'Registration failed',
      welcome_back: 'Welcome back, {name}!',
      welcome_new: 'Welcome, {name}!',
      cat_negozio: 'Shop',
      cat_negozio_desc: 'Single retail location',
      cat_ambulante: 'Street vendor',
      cat_ambulante_desc: 'Selling at markets and/or variable locations',
      cat_misto: 'Mixed',
      cat_misto_desc: 'Shop + markets',
      cat_tecnico: 'Technician',
      cat_tecnico_desc: 'On-site / home services',
      cat_servizi_sede: 'In-shop services',
      cat_servizi_sede_desc: 'On-site work without sales (hairdresser, mechanic…)',
    },
    footer: {
      privacy: 'Privacy',
      terms: 'Terms',
      cookie: 'Cookies',
      contact: 'Contact',
      copyright: '© {year} Kyloo · Free Beta version',
    },
    reviews: {
      title: 'Reviews',
      review_one: 'review',
      review_other: 'reviews',
      leave_review: 'Leave a review',
      your_rating: 'Your rating *',
      your_comment: 'Comment (optional)',
      comment_placeholder: 'Share your experience with this shop…',
      publish: 'Publish',
      update: 'Update review',
      thanks: 'Thanks for your review!',
      updated: 'Review updated',
      deleted: 'Review deleted',
      your_review: 'Your review',
      empty: 'No reviews yet.',
      empty_be_first: 'No reviews yet. Be the first!',
      login_to_review: 'Sign in to leave a review.',
      owner_response: 'Owner response',
      reply: 'Reply',
      reply_placeholder: 'Write a reply…',
      reply_sent: 'Reply posted',
      flag: 'Flag',
      flagged: 'Review flagged to admins',
      flagged_label: 'Flagged',
      confirm_delete: 'Delete your review?',
      confirm_flag: 'Flag this review to admins?',
      err_no_stars: 'Select at least 1 star',
      err_generic: 'Something went wrong. Try again.',
    },
  },
};

export const SUPPORTED_LANGS = ['it', 'en'];
export const DEFAULT_LANG = 'it';
